import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Typography, Button, Icon } from '@packages/ui/shared';
import { GestureResponderEvent, StyleSheet } from 'react-native';
import { useNavigate } from 'react-router-dom';

export interface CardProps {
    title: string;
    description: string;
    buttonText: string;
    buttonLink: string;
}

const useStyles = createUseStyles({
    card: {
        border: '1px solid #E3E3E3',
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '160px',
        padding: '24px',
    },
});

const styles = StyleSheet.create({
    title: {
        fontSize: 15,
        fontWeight: '600',
        lineHeight: 24,
        marginBottom: 8,
        overflow: 'hidden',
    },
    description: {
        fontSize: 15,
        fontWeight: '400',
        lineHeight: 24,
        marginTop: 'auto',
        marginBottom: 16,
        overflow: 'hidden',
    },
    button: {
        borderColor: '#1F518F',
        borderWidth: 1,
        paddingVertical: 0,
        maxWidth: '100%',
    },
    titleStyle: {
        overflow: 'hidden',
    },
});

export const DataCard: React.FC<CardProps> = ({ title, description, buttonText, buttonLink }) => {
    const classes = useStyles();
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    const handleNavigation = (event: GestureResponderEvent) => {
        event.preventDefault();
        navigate(buttonLink);
    };
    return (
        <div className={classes.card}>
            <Typography variant="statusBadge" style={styles.title} numberOfLines={1} color="black" ellipsizeMode="tail">
                {title}
            </Typography>
            <Typography style={styles.description} numberOfLines={1} color="textDarkSecondary" ellipsizeMode="tail">
                {description}
            </Typography>
            <div
                className={`d-flex justify-content-start mt-auto text-decoration-none w-auto`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <Button
                    style={styles.button}
                    iconRight={<Icon name="chevron-right" color="blueOne" />}
                    title={buttonText}
                    variant="ghost-blue"
                    onPress={handleNavigation}
                    titleStyle={styles.titleStyle}
                    numberOfLines={1}
                    accessibilityElementsHidden={true}
                    accessibilityRole="button"
                    accessibilityLabel={buttonText}
                />
            </div>
        </div>
    );
};
